import React from 'react';

import VehicleImage from 'components/VehicleImage';
import { Spacer } from '@ontruck/orc';
import { StyledSeparator } from 'modules/assignment-cards/styled';

const PrebookingVehicleInfo = ({ model }) => {
  if (!model) {
    return null;
  }

  const { vehicle_type, internal_notes } = model;

  return (
    <>
      <StyledSeparator mLeft="S" pRight="S">
        <VehicleImage type={vehicle_type} size="2.5rem" color="grey700" />
      </StyledSeparator>
      <Spacer mLeft="S" data-testid="pallets">
        {internal_notes}
      </Spacer>
    </>
  );
};

export default PrebookingVehicleInfo;
